module.exports = __webpack_public_path__ + "img/vertical_6_4_6005.0dd94324.png";